import { Injectable } from '@angular/core';

import { groupBy, keys } from 'lodash-es';

import { SportTreeItem } from '../../../competition-list/competition-list.models';

export interface SportListGroup {
    group: string;
    sports: SportTreeItem[];
}

@Injectable({ providedIn: 'root' })
export class SportListModalService {
    getGroups(links: SportTreeItem[]): SportListGroup[] {
        const grouped = groupBy(links, (link) => link.title.substring(0, 1));

        return keys(grouped)
            .map((key) => ({
                group: key,
                sports: grouped[key].sort(this.byName),
            }))
            .sort(this.byLetter);
    }

    getSingleGroup(links: SportTreeItem[]): SportListGroup[] {
        return [{ group: '', sports: links.sort(this.byName) }];
    }

    private byName = (first: SportTreeItem, second: SportTreeItem): number => first.title.localeCompare(second.title);
    private byLetter = (first: SportListGroup, second: SportListGroup): number => first.group.localeCompare(second.group);
}
